export default "__VITE_ASSET__BbBvig3f__"